<template>
   <div v-if="Object.keys(filterData).length > 0" v-show="open || (!aside && open)"
        :class="[aside ? asideCss : 'ct-offcanvas-panel map-filter-status-panel', {'d-none': !aside}, (!aside && open) ? 'd-md-block' : '']" :style="[aside ? '' : {'bottom': panelBottom}]">
        <div class="" >
            <div class="panel-filter-status" :class="{'aside': aside}">
                <template v-if="aside">
                    <div :class="asideCssHeader">
                        <a class="" aria-controls="#aside-map-filter-status" href="#aside-map-filter-status"
                            data-toggle="collapse" role="button" :aria-expanded="expanded" @click.prevent="expanded=!expanded" >
                            <div class="title">
                                Map view
                                <span class="right icon-collapse svg" :class="{'show': expanded}"></span>
                            </div>
                        </a>
                    </div>
                </template>
                <template v-else>
                    <!-- <div class="title">Map view</div> -->
                </template>
                <div :class="[asideCssBody, {'show': expanded}]">
                    <div class="d-flex flex-column">
                        <div class="item-filter d-flex flex-nowrap" v-for="item in filterData">
                            <div class="icon"><i class="fas fa-circle" :style="{'color':item.show ? item.color : '#c1c1c1'}" ></i></div>
                            <div class="d-flex flex-column flex-fill">
                                <div class="d-flex flex-nowrap justify-content-between align-items-center">
                                    <div class="label">{{item.name}}</div>
                                    <button type="button"
                                    class="btn btn-xs btn-toggle btn-azure" :class="{'active': item.show}"
                                    @click.prevent="!isActionMap && filterOccurrenceByStatusAndType(propName, item.id)"
                                     :aria-pressed="item.show" autocomplete="off">
                                        <div class="handle"></div>
                                    </button>
                                </div>
                                <div class="number">{{item.qty}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import MapFilterMixin from '../mixins/MapFilterMixin';

    export default {
        mixins: [
            MapFilterMixin
        ],
        props: {
            vfuncDataName: {
                type: String,
                default: 'getFilterStatusMap',
            },
            propName: {
                type: String,
                default: 'status',
            }
        },
        data() {
            return {
                idPanel: 'filterstatus',
                idFilterTypePanel: 'filtertype',
                bottom: '1rem',
                expanded: this.asideExpanded,
                previousStatus: false,
            }
        },
        mounted() {
            if(!this.aside){
                this.previousStatus = !this.open;
            }
        },
        created() {
            this.bottom = this.marginMapButtonPositionBottom || '1rem';
        },
        beforeDestroy() {
        },
        computed: {
            filterData() {
                return this.moduleCode ? this.$store.getters[`${this.moduleCode}/${this.vfuncDataName}`] : [];
            },
            filterTypePanel(){
                return this.$store.getters[`${this.moduleCode}/getPanel`](this.idFilterTypePanel);
            },
            collapsedFilterTypePanel() {
                return !!this.filterTypePanel.collapsed;
            },
            heightFilterTypePanel() {
                return this.filterTypePanel.height;
            },
            open() {
                return !this.collapsedFilterTypePanel;
            },
            enableUpdateBottom() {
                return this.layoutConf.map.updateMapButtonPositionBottom;
            },
            marginMapButtonPositionBottom() {
                return this.themeLayoutConfig.map.marginMapButtonPositionBottom;
            },
            panelBottom(){
                return this.enableUpdateBottom ? this.bottom : 'auto';
            },
        },
        methods: {
            updateBottomMargin(collapsed) {
                const refHeight = this.heightFilterTypePanel;
                this.bottom = this.bottom == 'auto' ? this.bottom : refHeight + 'px !important';
            },
        },
        watch: {
            heightFilterTypePanel: {
                immediate: true,
                handler(value, oldValue){
                    this.updateBottomMargin(value);
                },
            },
        }
    }
</script>

<style scoped lang="scss">

</style>
